import React, {useMemo} from 'react';
import {getStripeEnv} from 'mkt-ssr/lib/env';
import {
  getCdnHostForEnvironment,
  HostData,
} from 'mkt-ssr/lib/routing/getHostData';

const HostDataContext = React.createContext<HostData | undefined>(undefined);

interface HostDataProviderProps {
  value: HostData;
  children: React.ReactNode;
}

export function HostDataProvider({value, children}: HostDataProviderProps) {
  return (
    <HostDataContext.Provider value={value}>
      {children}
    </HostDataContext.Provider>
  );
}

export function useHostData(): HostData {
  const context = React.useContext(HostDataContext);
  if (context === undefined) {
    throw new Error('useHostData must be used within a HostDataProvider');
  }
  return context;
}

/**
 * Returns the asset prefix for the current environment.  This is used to prefix
 * image/font/etc. asset URLs with the correct CDN for the current environment (including
 * support for devboxes).
 */
export function useAssetPrefix() {
  const env = getStripeEnv();
  const hostData = useHostData();

  return useMemo(() => {
    return getCdnHostForEnvironment(hostData, env);
  }, [env, hostData]);
}
